import React from "react";

const GenericIcon = (props) => (
  <svg
    width={props.fatherProps.size || "1em"}
    height={props.fatherProps.size || "1em"}
    fill={props.fatherProps.color || "currentColor"}
    className={`icon ${props.fatherProps.className || ""}`}
    style={props.fatherProps.style}
    onClick={props.fatherProps.onClick}
    viewBox={props.viewBox || "0 0 16 16"}
    xmlns="http://www.w3.org/2000/svg"
    data-testid={props.fatherProps["data-testid"]}
  >
    {props.children}
  </svg>
);

export const IconInfo = (props) => (
  <GenericIcon fatherProps={props}>
    <path
      fillRule="evenodd"
      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    />
  </GenericIcon>
);

export const IconClose = (props) => (
  <GenericIcon fatherProps={props}>
    <path
      fillRule="evenodd"
      d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
    />
    <path
      fillRule="evenodd"
      d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
    />
  </GenericIcon>
);

export const IconChevonDown = (props) => (
  <GenericIcon fatherProps={props}>
    <path
      fillRule="evenodd"
      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
    />
  </GenericIcon>
);

export const IconCheck = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 16 14"}>
    <path
      fillRule="evenodd"
      d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"
    />
  </GenericIcon>
);

export const IconPlus = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 16 16"}>
    <path
      fillRule="evenodd"
      d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"
    />
    <path
      fillRule="evenodd"
      d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"
    />
  </GenericIcon>
);

export const IconArrowUpLeft = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 16 16"}>
    <path
      fillRule="evenodd"
      d="M2.5 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1H3.5V9a.5.5 0 0 1-1 0V4z"
    />
    <path
      fillRule="evenodd"
      d="M2.646 3.646a.5.5 0 0 1 .708 0l9 9a.5.5 0 0 1-.708.708l-9-9a.5.5 0 0 1 0-.708z"
    />
  </GenericIcon>
);

export const IconMarker = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 384 512"}>
    <path
      fill={props.color || "currentColor"}
      d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
    ></path>
  </GenericIcon>
);

export const IconLocation = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 37.375 37.375"}>
    <circle cx="18.687" cy="18.687" r="18.687" style={{ fill: "#757575" }} />
    <path
      d="M13.237 2A8.187 8.187 0 0 0 5 10.237c0 6.119 8.237 15.3 8.237 15.3s8.237-9.179 8.237-15.3A8.187 8.187 0 0 0 13.237 2zm0 11.179a2.942 2.942 0 1 1 2.942-2.942 2.913 2.913 0 0 1-2.942 2.942z"
      transform="translate(5.591 5.06)"
      style={{ fill: "#fff" }}
    />
  </GenericIcon>
);

export const IconForwardArrow = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 37.375 37.375"}>
    <path d="M0 0H37.375V37.375H0z" style={{ fill: "none" }} />
    <path
      d="M12.458 0l-2.18 2.18L19 10.9H0v3.115h19l-8.721 8.721 2.18 2.18 12.457-12.458z"
      transform="rotate(-135 16.863 14.283)"
      style={{ opacity: ".54" }}
    />
  </GenericIcon>
);

export const IconSpinner = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 512 512"}>
    <path
      fill={props.color || "currentColor"}
      d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
    ></path>
  </GenericIcon>
);

export const IconHome = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 16 16"}>
    <path
      fillRule="evenodd"
      d="M8 3.293l6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
    />
    <path
      fillRule="evenodd"
      d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
    />
  </GenericIcon>
);

export const IconMenu = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 56 56"}>
    <g
      id="prefix__Grupo_192"
      data-name="Grupo 192"
      transform="translate(-168 -88)"
    >
      <g
        id="prefix__Menu"
        clipPath="url(#prefix__clip-path)"
        transform="translate(182 103)"
      >
        <path
          id="prefix__Menu-2"
          fill="currentColor"
          d="M0 25v-3.572h17.5V25zm0-10.714v-3.572h28v3.572zM0 3.572V0h28v3.572z"
          data-name="Menu"
        />
      </g>
    </g>
  </GenericIcon>
);

export const IconArrowLeft = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 448 512"}>
    <path
      fill="currentColor"
      d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    ></path>
  </GenericIcon>
);

export const IconAdmin = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 37.234 37.234"}>
    <path
      id="prefix__admin"
      fill="currentColor"
      d="M36.4 14.285l-3.419-.839c-.162-.443-.348-.886-.557-1.327l1.781-2.968a1.091 1.091 0 0 0-.164-1.333L29.416 3.19a1.091 1.091 0 0 0-1.333-.164l-2.968 1.781c-.44-.209-.884-.4-1.327-.557L22.949.831A1.091 1.091 0 0 0 21.89 0h-6.545a1.091 1.091 0 0 0-1.059.831l-.84 3.419c-.443.162-.886.348-1.327.557L9.151 3.026a1.091 1.091 0 0 0-1.333.164L3.19 7.818a1.091 1.091 0 0 0-.164 1.333l1.781 2.968c-.209.44-.4.884-.557 1.327l-3.419.839A1.091 1.091 0 0 0 0 15.345v6.545a1.091 1.091 0 0 0 .831 1.059l3.419.839c.162.443.348.886.557 1.327l-1.781 2.968a1.091 1.091 0 0 0 .164 1.333l4.628 4.628a1.091 1.091 0 0 0 1.333.164l2.968-1.781c.44.209.884.4 1.327.557l.839 3.419a1.1 1.1 0 0 0 1.059.831h6.546a1.1 1.1 0 0 0 1.059-.831l.839-3.419c.443-.162.886-.348 1.327-.557l2.968 1.781a1.091 1.091 0 0 0 1.333-.164l4.628-4.628a1.091 1.091 0 0 0 .164-1.333l-1.781-2.968c.209-.44.4-.884.557-1.327l3.419-.839a1.091 1.091 0 0 0 .831-1.059v-6.545a1.091 1.091 0 0 0-.834-1.06zm-21.66 5.24l3.273 2.182a1.091 1.091 0 0 0 1.21 0l3.273-2.182a1.091 1.091 0 0 0 .486-.908v-6.268a7.636 7.636 0 1 1-8.727 0v6.268a1.091 1.091 0 0 0 .485.908zm3.878 8.91a9.811 9.811 0 0 0 2.182-.245v6.863h-4.365V28.19a9.812 9.812 0 0 0 2.182.245zm16.435-7.4l-3.168.778a1.091 1.091 0 0 0-.78.731 13.065 13.065 0 0 1-.886 2.115 1.091 1.091 0 0 0 .031 1.067l1.65 2.751-3.424 3.423-2.751-1.65a1.091 1.091 0 0 0-1.067-.031 13.347 13.347 0 0 1-1.677.738V27.41A9.819 9.819 0 0 0 22.3 9.516a1.091 1.091 0 0 0-1.5 1.011v7.506l-2.182 1.454-2.182-1.454v-7.506a1.091 1.091 0 0 0-1.5-1.011 9.816 9.816 0 0 0-.681 17.894v3.546a13.358 13.358 0 0 1-1.677-.738 1.091 1.091 0 0 0-1.067.031L8.759 31.9l-3.424-3.424 1.65-2.751a1.091 1.091 0 0 0 .031-1.067 13.059 13.059 0 0 1-.886-2.115 1.091 1.091 0 0 0-.78-.731l-3.169-.778V16.2l3.168-.778a1.091 1.091 0 0 0 .78-.731 13.066 13.066 0 0 1 .886-2.115 1.091 1.091 0 0 0-.031-1.067l-1.649-2.75 3.424-3.424 2.751 1.65a1.091 1.091 0 0 0 1.067.031 13.059 13.059 0 0 1 2.115-.886 1.091 1.091 0 0 0 .731-.78l.777-3.168h4.834l.778 3.168a1.091 1.091 0 0 0 .731.78 13.059 13.059 0 0 1 2.115.886 1.091 1.091 0 0 0 1.067-.031l2.751-1.65L31.9 8.759l-1.65 2.751a1.091 1.091 0 0 0-.031 1.067 13.059 13.059 0 0 1 .886 2.115 1.091 1.091 0 0 0 .78.731l3.168.778z"
    />
  </GenericIcon>
);

export const IconDollar = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 37.742 37.742"}>
    <path
      id="prefix__Caminho_66"
      d="M18.871 37.742A18.871 18.871 0 0 1 5.527 5.527a18.871 18.871 0 0 1 26.688 26.688 18.747 18.747 0 0 1-13.344 5.527zm0-35.383a16.512 16.512 0 1 0 16.512 16.512A16.531 16.531 0 0 0 18.871 2.359z"
      fillRule="currentColor"
      data-name="Caminho 66"
    />
    <path
      id="prefix__Caminho_67"
      d="M189.307 106.615a2.949 2.949 0 1 1 2.949-2.949 1.179 1.179 0 1 0 2.359 0 5.316 5.316 0 0 0-4.128-5.174v-1.313a1.179 1.179 0 0 0-2.359 0v1.313a5.307 5.307 0 0 0 1.179 10.481 2.949 2.949 0 1 1-2.949 2.949 1.179 1.179 0 0 0-2.359 0 5.316 5.316 0 0 0 4.128 5.174v1.313a1.179 1.179 0 0 0 2.359 0V117.1a5.307 5.307 0 0 0-1.179-10.481z"
      fillRule="currentColor"
      data-name="Caminho 67"
      transform="translate(-170.436 -88.923)"
    />
  </GenericIcon>
);

export const IconHomeOutline = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 38 34.079"}>
    <g
      id="prefix__Grupo_250"
      data-name="Grupo 250"
      transform="translate(-1125.872 -97.822)"
    >
      <path
        id="prefix__Caminho_233"
        fill="currentColor"
        d="M749.429 195.871h-8.48a1.517 1.517 0 0 1-1.515-1.515v-7.784h-5.8v7.784a1.517 1.517 0 0 1-1.516 1.515h-8.48a1.544 1.544 0 0 1-1.542-1.542v-12.762h-3.625a1.565 1.565 0 0 1-1.337-.717 1.543 1.543 0 0 1 .261-1.964l18-16.685a1.543 1.543 0 0 1 2.081-.011l3.87 3.551v-2.107h8.054v9.5l6.27 5.753a1.54 1.54 0 0 1 .265 1.962 1.562 1.562 0 0 1-1.339.721h-3.626v12.762a1.544 1.544 0 0 1-1.541 1.539zm-8.211-1.785h7.968v-14.3h4.822l-6.394-5.866v-8.5h-4.483v4.38l-6.688-6.137-17.391 16.118h4.826v14.3h7.968v-7.621a1.68 1.68 0 0 1 1.678-1.678h6.014a1.68 1.68 0 0 1 1.678 1.678z"
        data-name="Caminho 233"
        transform="translate(408.979 -63.97)"
      />
    </g>
  </GenericIcon>
);

export const IconDelivery = (props) => (
  <GenericIcon fatherProps={props} viewBox={"9 0 45.734 30.789"}>
    <defs></defs>
    <g id="Grupo_296" transform="translate(3650.25 -842.607)">
      <g
        id="Elipse_230"
        class="cls-1"
        transform="translate(-3624.942 861.883)"
        style={{ fill: "none", stroke: "CurrentColor", strokeWidth: "1.5px" }}
      >
        <circle cx="3.757" cy="3.757" r="3.757" class="cls-4" />
        <circle cx="3.757" cy="3.757" r="3.007" class="cls-5" />
      </g>
      <g
        id="Elipse_231"
        class="cls-1"
        transform="translate(-3607.156 861.883)"
        style={{ fill: "none", stroke: "CurrentColor", strokeWidth: "1.5px" }}
      >
        <circle cx="3.757" cy="3.757" r="3.757" class="cls-4" />
        <circle cx="3.757" cy="3.757" r="3.007" class="cls-5" />
      </g>
      <path
        id="Caminho_276"
        d="M-3529.217 867.966v5.126h7.8"
        class="cls-2"
        transform="translate(-75.332 -15.744)"
        style={{
          fill: "none",
          stroke: "CurrentColor",
          strokeWidth: "1.5px",
          strokeLinecap: "round",
        }}
      />
      <path
        id="Caminho_277"
        d="M-3534.674 874.282h2.664a1.134 1.134 0 0 0 1.267-1.327V866.7s-3.044-5.989-3.619-7.169a1.654 1.654 0 0 0-1.615-1.045h-6.285a2.746 2.746 0 0 0-2.765 3.166c.094 3.251 0 12.626 0 12.626"
        class="cls-1"
        transform="translate(-65.538 -9.354)"
      />
      <path
        id="Caminho_1224"
        d="M-4.1 0H8.082"
        class="cls-1"
        transform="translate(-3614.33 864.784)"
        style={{ fill: "none", stroke: "CurrentColor", strokeWidth: "1.5px" }}
      />
      <g
        id="Elipse_236"
        class="cls-1"
        transform="translate(-3633.942 861.883)"
        style={{ fill: "none", stroke: "CurrentColor", strokeWidth: "1.5px" }}
      >
        <circle cx="3.757" cy="3.757" r="3.757" class="cls-4" />
        <circle cx="3.757" cy="3.757" r="3.007" class="cls-5" />
      </g>
      <path
        id="Linha_82"
        d="M0 0L3 0"
        class="cls-1"
        transform="translate(-3627 864.784)"
        style={{ fill: "none", stroke: "CurrentColor", strokeWidth: "1.5px" }}
      />
      <g id="Caminho_1225" fill="none">
        <path
          d="M7.3 0h14.6c4.033 0 7.3 3.582 7.3 8s-3.269 8-7.3 8H7.3C3.269 16 0 12.418 0 8s3.269-8 7.3-8z"
          class="cls-4"
          transform="translate(-3641.706 842.607)"
        />
        <path
          d="M7.302 1.5C4.102 1.5 1.5 4.416 1.5 8s2.603 6.5 5.802 6.5h14.603c3.199 0 5.801-2.916 5.801-6.5s-2.602-6.5-5.801-6.5H7.302m0-1.5h14.603c4.032 0 7.301 3.582 7.301 8s-3.269 8-7.301 8H7.302C3.269 16 0 12.418 0 8s3.269-8 7.302-8z"
          transform="translate(-3641.706 842.607)"
          fill="currentColor"
        />
      </g>
      <g id="Grupo_2409" transform="translate(-9 -2)">
        <path
          id="Linha_26"
          d="M0 0L1.956 0"
          class="cls-2"
          transform="translate(-3637.566 849.137)"
          style={{
            fill: "none",
            stroke: "CurrentColor",
            strokeWidth: "1.5px",
            strokeLinecap: "round",
          }}
          fill="currentColor"
        />
        <path
          id="Linha_27"
          d="M0 0L10.106 0"
          class="cls-2"
          transform="translate(-3633.328 849.137)"
          style={{
            fill: "none",
            stroke: "CurrentColor",
            strokeWidth: "1.5px",
            strokeLinecap: "round",
          }}
        />
        <path
          id="Linha_28"
          d="M0 0L10.106 0"
          class="cls-2"
          transform="translate(-3637.566 853.048)"
          style={{
            fill: "none",
            stroke: "CurrentColor",
            strokeWidth: "1.5px",
            strokeLinecap: "round",
          }}
        />
        <path
          id="Linha_29"
          d="M0 0L10.106 0"
          class="cls-2"
          transform="translate(-3634.632 856.634)"
          style={{
            fill: "none",
            stroke: "CurrentColor",
            strokeWidth: "1.5px",
            strokeLinecap: "round",
          }}
        />
        <path
          id="Linha_30"
          d="M0 0L3.912 0"
          class="cls-2"
          transform="translate(-3640.5 856.634)"
          style={{
            fill: "none",
            stroke: "CurrentColor",
            strokeWidth: "1.5px",
            strokeLinecap: "round",
          }}
        />
      </g>
      <path
        id="Caminho_1226"
        d="M-3640.268 865.64h-1.827c-2.619 0-2.395-2.131-2.395-2.131s-.058-1.932 2.395-1.85 24.751 0 24.751 0"
        class="cls-1"
        transform="translate(7 -1)"
        style={{ fill: "none", stroke: "CurrentColor", strokeWidth: "1.5px" }}
      />
    </g>
  </GenericIcon>
);

export const IconHomeSign = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 37.792 37.801"}>
    <g id="prefix__home-sign" transform="translate(-1.872 -4.07)">
      <g id="prefix__bar-chart" transform="translate(1.872 4.07)">
        <g
          id="prefix__Grupo_156"
          data-name="Grupo 156"
          transform="translate(0 10.827)"
        >
          <g id="prefix__Grupo_155" data-name="Grupo 155">
            <path
              id="prefix__Caminho_66"
              d="M48.655 172.151h-1.619v-23.512a1.987 1.987 0 0 0-1.985-1.985h-3.619a1.987 1.987 0 0 0-1.985 1.985v23.512h-4.112v-12.86a1.987 1.987 0 0 0-1.985-1.985h-3.619a1.987 1.987 0 0 0-1.985 1.985v12.859h-4.111v-6.66a1.987 1.987 0 0 0-1.985-1.985h-3.619a1.987 1.987 0 0 0-1.985 1.985v6.66h-1.707a.738.738 0 1 0 0 1.477h34.316a.738.738 0 1 0 0-1.477zm-26.5 0h-4.633v-6.66a.509.509 0 0 1 .508-.508h3.62a.509.509 0 0 1 .508.508zm11.7 0h-4.632v-12.86a.509.509 0 0 1 .508-.508h3.619a.509.509 0 0 1 .508.508zm11.7 0h-4.631v-23.512a.509.509 0 0 1 .508-.508h3.619a.509.509 0 0 1 .508.508v23.512z"
              fillRule="currentColor"
              data-name="Caminho 66"
              transform="translate(-13.601 -146.654)"
            />
          </g>
        </g>
        <g
          id="prefix__Grupo_158"
          data-name="Grupo 158"
          transform="translate(6.331)"
        >
          <g id="prefix__Grupo_157" data-name="Grupo 157">
            <path
              id="prefix__Caminho_67"
              d="M126.449.776a.736.736 0 0 0-.775-.776H121.171a.738.738 0 0 0 0 1.477h2.758l-7.3 7.3-2.752-2.752a.738.738 0 0 0-1.044 0L99.562 19.3a.738.738 0 0 0 1.044 1.044l12.75-12.75 2.752 2.752a.738.738 0 0 0 1.044 0l7.821-7.821v2.5a.738.738 0 1 0 1.477 0V.812c.001-.012-.001-.024-.001-.036z"
              fillRule="currentColor"
              data-name="Caminho 67"
              transform="translate(-99.346)"
            />
          </g>
        </g>
        <g
          id="prefix__Grupo_160"
          data-name="Grupo 160"
          transform="translate(3.842 21.655)"
        >
          <g id="prefix__Grupo_159" data-name="Grupo 159">
            <circle
              id="prefix__Elipse_30"
              cx=".738"
              cy=".738"
              r=".738"
              fillRule="currentColor"
              data-name="Elipse 30"
            />
          </g>
        </g>
      </g>
    </g>
  </GenericIcon>
);

export const IconSearch = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 16 16"}>
    <path
      fillRule="evenodd"
      d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"
    />
    <path
      fillRule="evenodd"
      d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
    />
  </GenericIcon>
);

export const IconTelephone = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 90.742 50.742"}>
    <path
      data-name="layer1"
      d="M58.9 47l-10.4-6.8a4.8 4.8 0 0 0-6.5 1.3c-2.4 2.9-5.3 7.7-16.2-3.2S19.6 24.4 22.5 22a4.8 4.8 0 0 0 1.3-6.5L17 5.1c-.9-1.3-2.1-3.4-4.9-3S2 6.6 2 15.6s7.1 20 16.8 29.7S39.5 62 48.4 62s13.2-8 13.5-10-1.7-4.1-3-5z"
      fill="#9cf"
    ></path>
    <path
      data-name="opacity"
      d="M50.4 57c-9 0-20-7.1-29.7-16.8S4 19.5 4 10.6A14.1 14.1 0 0 1 4.2 8 13.6 13.6 0 0 0 2 15.6c0 9 7.1 20 16.8 29.7S39.5 62 48.4 62s13.2-8 13.5-10a4.5 4.5 0 0 0 0-1 14.1 14.1 0 0 1-11.5 6z"
      fill="#000064"
      opacity=".15"
    ></path>
    <path
      data-name="stroke"
      d="M58.9 47l-10.4-6.8a4.8 4.8 0 0 0-6.5 1.3c-2.4 2.9-5.3 7.7-16.2-3.2S19.6 24.4 22.5 22a4.8 4.8 0 0 0 1.3-6.5L17 5.1c-.9-1.3-2.1-3.4-4.9-3S2 6.6 2 15.6s7.1 20 16.8 29.7S39.5 62 48.4 62s13.2-8 13.5-10-1.7-4.1-3-5z"
      fill="none"
      stroke="#2e4369"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="2"
      stroke-linejoin="round"
    ></path>
  </GenericIcon>
);

export const IconEmail = (props) => (
  <GenericIcon fatherProps={props} viewBox={"0 0 90.742 50.742"}>
    <path
      data-name="layer2"
      fill="none"
      stroke="#ffffff"
      stroke-miterlimit="10"
      stroke-width="2"
      d="M2 12l30 29 30-29M42 31.6L62 52M2 52l20-20.4"
      stroke-linejoin="round"
      stroke-linecap="round"
    ></path>
    <path
      data-name="layer1"
      fill="none"
      stroke="#ffffff"
      stroke-miterlimit="10"
      stroke-width="2"
      d="M2 12h60v40H2z"
      stroke-linejoin="round"
      stroke-linecap="round"
    ></path>
  </GenericIcon>
);
